import FJLeftPanelHeader from '../../../common/FJLeftPanelHeader.jsx';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import styles from './FJEditPanel.module.less';
import FJTextPreviewContainer from '../container/FJTextPreviewContainer.jsx';
import FJToolContainer from '../container/FJToolContainer.jsx';

const FJEditPanel = props => {
    const { goBack } = props;
    return (
        <div className={styles.box}>
            <FJLeftPanelHeader text={FJLocalStore._('ai-text-based-editing')} onClick={goBack} />
            <FJToolContainer />
            <FJTextPreviewContainer />
        </div>
    );
};

export default FJEditPanel;
